(function() {
    'use strict';

    if (window.__NEPDPDiscountPriceStableV2) return;
    window.__NEPDPDiscountPriceStableV2 = true;

    var scriptConfig = document.currentScript;
    var PDP_PRODUCT_ID = scriptConfig && scriptConfig.dataset.pdpProductId
      ? String(scriptConfig.dataset.pdpProductId)
      : null;
    var currentSignature = '';
    var updateTimer = null;
    var subscriptionBaseCents = null;
    var lastVerifiedDiscountCode = '';
    var lastVerifiedDiscountPercentage = 0;

    function normalizeCode(code) {
      return String(code || '').trim().toUpperCase();
    }

    function isSubscriptionActive() {
      return !!document.querySelector(
        '.subscription-option--abo.subscription-option--active, ' +
        '[name="subscription_switcher"]:checked[value="subscription_plan_id"]'
      );
    }

    function getDiscountDetails() {
      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.getDetails === 'function'
      ) {
        try {
          var details = window.NE.DiscountTracker.getDetails();

          if (details && details.code) {
            return {
              code: normalizeCode(details.code),
              percentage: Number(details.percentage || 0)
            };
          }
        } catch (e) {}
      }

      try {
        var cached = sessionStorage.getItem('ne_discount_details');

        if (cached) {
          var parsed = JSON.parse(cached);

          if (parsed && parsed.code) {
            return {
              code: normalizeCode(parsed.code),
              percentage: Number(parsed.percentage || 0)
            };
          }
        }
      } catch (e) {}

      try {
        var storedCode = sessionStorage.getItem('ne_discount_code');

        if (storedCode) {
          return {
            code: normalizeCode(storedCode),
            percentage: 0
          };
        }
      } catch (e) {}

      return null;
    }

    function getPriceElement() {
      var productSection = document.querySelector(
        '[data-section-type="product"][data-is-full-product="true"]'
      );

      return productSection
        ? productSection.querySelector('.product__price span[data-price]')
        : document.querySelector('.template-product .product__price span[data-price]');
    }

    function getProductId() {
      if (PDP_PRODUCT_ID) return PDP_PRODUCT_ID;

      if (window.meta && window.meta.product && window.meta.product.id) {
        return String(window.meta.product.id);
      }

      var productSection = document.querySelector(
        '[data-section-type="product"][data-is-full-product="true"][data-product-id]'
      );

      return productSection ? productSection.getAttribute('data-product-id') : null;
    }

    function formatPrice(price) {
      return window.NE.Utils.formatMoney(Math.round(Number(price || 0) * 100));
    }

    function formatPriceCents(priceCents) {
      return window.NE.Utils.formatMoney(Math.round(Number(priceCents || 0)));
    }

    function parsePriceCents(value) {
      var normalized = String(value || '')
        .replace(/\s/g, '')
        .replace(/[^\d,.-]/g, '');

      if (!normalized) return 0;

      var commaIndex = normalized.lastIndexOf(',');
      var dotIndex = normalized.lastIndexOf('.');
      var decimalIndex = Math.max(commaIndex, dotIndex);

      if (decimalIndex >= 0) {
        var whole = normalized.slice(0, decimalIndex).replace(/[.,]/g, '');
        var decimals = normalized.slice(decimalIndex + 1).replace(/[.,]/g, '');
        normalized = whole + '.' + decimals;
      }

      return Math.round((parseFloat(normalized) || 0) * 100);
    }

    function getPurchaseOptionPrices() {
      return [
        {
          price: document.querySelector('.single_buy_price'),
          oldPrice: document.querySelector('.single_buy_old_price')
        },
        {
          price: document.querySelector('.subscription_price'),
          oldPrice: document.querySelector('.p_option_old_price')
        }
      ];
    }

    function setSubscriptionOptionPriceVisibility(isVisible) {
      var option = getPurchaseOptionPrices()[1];
      var priceBlock = option && option.price
        ? option.price.closest('.s_o_price')
        : null;

      if (!priceBlock) return;

      priceBlock.hidden = !isVisible;
      priceBlock.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      priceBlock.style.display = isVisible ? '' : 'none';
    }

    function capturePurchaseOptionBase(option, force) {
      if (!option.price) return 0;

      if (
        force ||
        !option.price.hasAttribute('data-ne-purchase-option-base-cents')
      ) {
        var baseCents = parsePriceCents(option.price.textContent);

        if (baseCents > 0) {
          option.price.setAttribute(
            'data-ne-purchase-option-base-cents',
            String(baseCents)
          );
        }
      }

      return Number(
        option.price.getAttribute('data-ne-purchase-option-base-cents') || 0
      );
    }

    function getSubscriptionPlanBaseCents() {
      var purchaseOptions = getPurchaseOptionPrices();
      var oneTimeBaseCents = capturePurchaseOptionBase(
        purchaseOptions[0],
        false
      );
      var select = document.querySelector('[name="subscription_options"]');
      var selectedOption = select && select.options
        ? select.options[select.selectedIndex]
        : null;

      if (!oneTimeBaseCents || !selectedOption) return 0;

      var discountValue = Number(
        selectedOption.getAttribute('discount_value') || 0
      );
      var discountType = selectedOption.getAttribute('discount_type');

      if (!discountValue) return oneTimeBaseCents;

      return Math.round(
        discountType === 'percentage'
          ? oneTimeBaseCents - (oneTimeBaseCents * discountValue / 100)
          : oneTimeBaseCents - discountValue
      );
    }

    function renderPurchaseOptionPrices(percentage) {
      getPurchaseOptionPrices().forEach(function(option, index) {
        if (!option.price) return;

        var baseCents = index === 1
          ? getSubscriptionPlanBaseCents()
          : capturePurchaseOptionBase(option, false);
        if (!baseCents) return;

        if (index === 1) {
          option.price.setAttribute(
            'data-ne-purchase-option-base-cents',
            String(baseCents)
          );
        }

        if (option.oldPrice) {
          if (!option.oldPrice.hasAttribute('data-ne-original-text')) {
            option.oldPrice.setAttribute(
              'data-ne-original-text',
              option.oldPrice.textContent || ''
            );
          }

          option.oldPrice.textContent = formatPriceCents(baseCents);
        }

        option.price.textContent = formatPriceCents(
          baseCents - (baseCents * percentage / 100)
        );
        option.price.setAttribute('data-ne-purchase-option-discount', 'true');

        if (index === 1) {
          option.price.classList.remove('sale');
          setSubscriptionOptionPriceVisibility(true);
        }
      });
    }

    function restorePurchaseOptionPrices() {
      getPurchaseOptionPrices().forEach(function(option) {
        if (
          !option.price ||
          option.price.getAttribute('data-ne-purchase-option-discount') !== 'true'
        ) {
          return;
        }

        var baseCents = Number(
          option.price.getAttribute('data-ne-purchase-option-base-cents') || 0
        );

        if (baseCents > 0) {
          option.price.textContent = formatPriceCents(baseCents);
        }

        option.price.removeAttribute('data-ne-purchase-option-discount');

        if (
          option.oldPrice &&
          option.oldPrice.hasAttribute('data-ne-original-text')
        ) {
          option.oldPrice.textContent =
            option.oldPrice.getAttribute('data-ne-original-text') || '';
          option.oldPrice.removeAttribute('data-ne-original-text');
        }
      });

      setSubscriptionOptionPriceVisibility(true);
    }

    function recaptureSubscriptionOptionBase() {
      var option = getPurchaseOptionPrices()[1];
      if (!option || !option.price) return;

      option.price.removeAttribute('data-ne-purchase-option-discount');
      capturePurchaseOptionBase(option, true);
    }

    function initializeSubscriptionOptionBase() {
      var option = getPurchaseOptionPrices()[1];
      if (!option || !option.price) return;

      var baseCents = getSubscriptionPlanBaseCents();
      if (baseCents > 0) {
        option.price.setAttribute(
          'data-ne-purchase-option-base-cents',
          String(baseCents)
        );
        option.price.textContent = formatPriceCents(baseCents);
      } else {
        recaptureSubscriptionOptionBase();
      }

      option.price.classList.remove('sale');
      setSubscriptionOptionPriceVisibility(true);

      if (isSubscriptionActive()) {
        subscriptionBaseCents = capturePurchaseOptionBase(option, false);
      }
    }

    function getBasePrice(priceElement) {
      if (
        isSubscriptionActive() &&
        subscriptionBaseCents !== null &&
        Number(subscriptionBaseCents) > 0
      ) {
        return Number(subscriptionBaseCents) / 100;
      }

      var priceValue = priceElement ? priceElement.getAttribute('data-price') : null;
      if (!priceValue) return 0;

      return parseFloat(String(priceValue).replace(',', '.')) || 0;
    }

    function restorePrice(priceElement) {
      if (priceElement && priceElement.hasAttribute('data-shopify-original-html')) {
        priceElement.innerHTML = priceElement.getAttribute('data-shopify-original-html');
        priceElement.removeAttribute('data-shopify-original-html');
        priceElement.removeAttribute('data-ne-pdp-discount-price');
      }

      restorePurchaseOptionPrices();
      currentSignature = '';
    }

    function renderPrice(priceElement, percentage, code) {
      if (!priceElement || !percentage || percentage <= 0) {
        restorePrice(priceElement);
        return;
      }

      var originalPrice = getBasePrice(priceElement);
      if (!originalPrice || isNaN(originalPrice)) return;

      if (!priceElement.hasAttribute('data-shopify-original-html')) {
        priceElement.setAttribute('data-shopify-original-html', priceElement.innerHTML);
      }

      var discountedPrice = originalPrice - (originalPrice * percentage / 100);
      var signature = normalizeCode(code) + '|' + originalPrice + '|' + percentage + '|' + (isSubscriptionActive() ? 'sub' : 'normal');

      renderPurchaseOptionPrices(percentage);

      if (
        signature === currentSignature &&
        priceElement.getAttribute('data-ne-pdp-discount-price') === 'true'
      ) {
        return;
      }

      currentSignature = signature;

      priceElement.innerHTML =
        '<span class="ne-discount-price-wrapper">' +
          '<span class="ne-discount-price__discounted">' + formatPrice(discountedPrice) + '</span>' +
          '<span class="ne-discount-price__original">' + formatPrice(originalPrice) + '</span>' +
        '</span>';

      priceElement.setAttribute('data-ne-pdp-discount-price', 'true');
    }

    function updatePDPPrice() {
      if (!document.body.classList.contains('template-product')) return;

      var priceElement = getPriceElement();
      if (!priceElement) return;

      var details = getDiscountDetails();
      var productId = getProductId();

      if (!details || !details.code) {
        restorePrice(priceElement);
        return;
      }

      if (
        window.NE &&
        window.NE.DiscountTracker &&
        typeof window.NE.DiscountTracker.fetchProductDiscount === 'function' &&
        productId
      ) {
        window.NE.DiscountTracker.fetchProductDiscount(details.code, productId)
          .then(function(percentage) {
            percentage = Number(percentage || 0);

            if (percentage > 0) {
              lastVerifiedDiscountCode = normalizeCode(details.code);
              lastVerifiedDiscountPercentage = percentage;
              renderPrice(priceElement, percentage, details.code);
            } else {
              lastVerifiedDiscountCode = '';
              lastVerifiedDiscountPercentage = 0;
              restorePrice(priceElement);
            }
          })
          .catch(function() {
            lastVerifiedDiscountCode = '';
            lastVerifiedDiscountPercentage = 0;
            restorePrice(priceElement);
          });
      } else {
        lastVerifiedDiscountCode = '';
        lastVerifiedDiscountPercentage = 0;
        restorePrice(priceElement);
      }
    }

    function scheduleUpdate(delay) {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function() {
        requestAnimationFrame(updatePDPPrice);
      }, typeof delay === 'number' ? delay : 120);
    }

    function init() {
      if (!document.body.classList.contains('template-product')) return;

      initializeSubscriptionOptionBase();
      scheduleUpdate(200);

      window.addEventListener('ne:discount-code-updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      window.addEventListener('ne:discount-details-updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      document.addEventListener('discount:updated', function() {
        currentSignature = '';
        scheduleUpdate(250);
      });

      document.addEventListener('subscription:changed', function(event) {
        recaptureSubscriptionOptionBase();

        if (
          event.detail &&
          event.detail.subscriptionPlanId &&
          event.detail.finalPriceCents
        ) {
          subscriptionBaseCents = Number(event.detail.finalPriceCents || 0);
        } else {
          subscriptionBaseCents = null;
        }

        currentSignature = '';

        var priceElement = getPriceElement();
        if (priceElement) {
          priceElement.removeAttribute('data-shopify-original-html');
          priceElement.removeAttribute('data-ne-pdp-discount-price');

          var details = getDiscountDetails();
          if (
            details &&
            lastVerifiedDiscountPercentage > 0 &&
            normalizeCode(details.code) === lastVerifiedDiscountCode
          ) {
            renderPrice(
              priceElement,
              lastVerifiedDiscountPercentage,
              lastVerifiedDiscountCode
            );
          }
        }

        scheduleUpdate(80);
      });

      window.addEventListener('ne:discount-code-cleared', function() {
        restorePrice(getPriceElement());
      });

      var priceElement = getPriceElement();

      if (priceElement) {
        var observer = new MutationObserver(function(mutations) {
          var shouldUpdate = false;

          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-price') {
              shouldUpdate = true;
            }
          });

          if (shouldUpdate) {
            currentSignature = '';
            scheduleUpdate(120);
          }
        });

        observer.observe(priceElement, {
          attributes: true,
          attributeFilter: ['data-price']
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
      })();
